﻿import $ from "jquery";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailBenutzer extends GuiDetailGeneric {
    constructor() {
        super("Benutzer");
    }

    override attachEvents(): void {
        super.attachEvents();
        $("#btnSendNewPassword").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickSendAktivierung(e));
        $("#btnUnlockUser").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickUnlockUser(e));
        $("#btnObfuscateUser").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickObfuscateUser(e));
        $("#btnCopyLink").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickCopyLink(e));
        $("#btnReset2FA").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButtonConfirm(e));

        $("#btnAzureInvite").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButtonConfirm(e));
        $("#btnAzureRemove").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButtonConfirm(e));

        $("#btnAnfallstelleAdd").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickAnfallstelleAdd(e));

        // EanvSignatur
        $("#btnEanvRemove").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButtonConfirm(e));
        $("#btnEanvCreate").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButtonConfirm(e));

    }

    clickAnfallstelleAdd(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickAnfallstelleAdd");
        this.doAction(e);
    }

    private clickSendAktivierung(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickSendAktivierung");
        this.clickActionButtonConfirm(e);
    }

    private clickUnlockUser(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickUnlockUser");
        this.clickActionButtonConfirm(e);
    }

    private clickObfuscateUser(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickObfuscateUser");
        this.clickActionButtonConfirm(e);
    }

    private clickCopyLink(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickCopyLink");
        e.preventDefault();
        this.copyFieldToClipboard("#VmDetail_AktivierungsLink").catch((err: unknown) => {
            this.log(`copyFieldToClipboard fehlgeschlagen: ${String(err)}`);
            this.createToastValidate("Zwischenablage", "Kopieren nicht möglich. Bitte den Link manuell markieren und kopieren.", "warning", 5000);
        });
    }

    // Kopiert den Wert eines Eingabefelds (z. B. Aktivierungslink) in die Zwischenablage
    private copyFieldToClipboard(selector: string): Promise<void> {
        this.log(`copyFieldToClipboard: ${selector}`);
        const text = $(selector).val() as string;

        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            return navigator.clipboard.writeText(text);
        }
        return Promise.reject(new Error("The Clipboard API is not available."));
    }
}
